import { batch, signal } from "@preact/signals-react"

import { GROUPED_BY } from "@constants"


export const catalogueAnalyzerRowClick = signal(null)
export const catalogueAnalyzerTabSelected = signal(GROUPED_BY.BRAND)
export const elementsInLoading = signal([])

export const resetCatalogueGeneral = () => batch(() => {
    catalogueAnalyzerRowClick.value = null
    catalogueAnalyzerTabSelected.value = GROUPED_BY.BRAND
    elementsInLoading.value = []
})